import ProjectDocumentSlice from "../slices/ProjectDocumentSlice";
import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import ProjectDocumentService from "../../services/ProjectDocumentService";
import { ProjectDocumentModel } from "../../models/ProjectDocumentModel";

export const ProjectDocumentActions = ProjectDocumentSlice.actions;
export const fetchProjectDocuments = (projectId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
            const response: ProjectDocumentModel[] = await ProjectDocumentService.getProjectDocumentsByProjectId(projectId);
            dispatch(ProjectDocumentActions.setParticularProjectDocuments(response));
    }
}